import React from 'react';
import { formatListValue } from '@/shared/components/FormattedListValue';
import { useIntl } from 'react-intl';
import messages from './FieldMessages';

const RelationLinkChange = props => {
  const intl = useIntl();
  const { log, relations } = props;

  const renderLinkType = () =>
    formatListValue({ log, intl, list: 'linktypeto', id: log.newValue.Type });
  const renderNewRelation = () => (
    <span>
      {intl.formatMessage(messages.AddedLink, {
        linkType: renderLinkType(),
        relation: relations[log.newValue.Id],
        b: value => <b>{value}</b>,
        i: value => <i>{value}</i>,
      })}
    </span>
  );
  const renderRemovedRelation = () => (
    <span>
      {intl.formatMessage(messages.RemovedLink, {
        linkType: renderLinkType(),
        relation: relations[log.oldValue.Id],
        b: value => <b>{value}</b>,
        i: value => <i>{value}</i>,
      })}
    </span>
  );

  return <span>{log.oldValue.Id === null ? renderNewRelation() : renderRemovedRelation()}</span>;
};

export default RelationLinkChange;
